import { ellipsis } from "@/common/style/commonStyle";
import { makeStyles } from "@fluentui/react-components";

export const useStyle = makeStyles({
	menuItem: {
		paddingLeft: "12px",
		paddingRight: "24px",
		width: "100%",

		"& span:nth-of-type(2)": {
			...ellipsis(),
		},

		"& span:nth-of-type(1)": {
			flexShrink: 0,
		},
	},
});
